import { useField, useFormikContext } from "formik";
import React, { forwardRef, RefObject } from "react";
import Recaptcha from "react-recaptcha";
import siteConfig from "../../config/siteConfig";
import useTranslations from "../../hooks/useTranslations";
import { isNullOrWhiteSpace } from "../../shared/string";
import { ReCaptcha } from "../ReCaptcha";
import InputContainer from "./Inputs/InputContainer";

type FormikRecaptchaProps = {
  id: string;
};

const FormikRecaptcha = forwardRef(
  ({ id }: FormikRecaptchaProps, ref: RefObject<Recaptcha>) => {
    const translations = useTranslations();
    const [field, meta] = useField({
      // Note: Netlify requires the recaptcha field to be named "g-recaptcha-response". However, the Recaptcha elementID
      // must be a different name since it will generate a textarea with id "g-recaptcha-response".
      name: "g-recaptcha-response",
      validate: value => {
        if (isNullOrWhiteSpace(value)) {
          return translations.recaptcha ?? "";
        }
      }
    });

    const { submitForm } = useFormikContext();

    return (
      <InputContainer meta={meta}>
        <ReCaptcha
          ref={ref}
          sitekey={siteConfig.reCaptchaSiteKey}
          size="invisible"
          elementID={id}
          render="explicit"
          onloadCallback={() => {
            // onloadCallback must be defined for explicit rendering to work
          }}
          verifyCallback={response => {
            field.onChange(response);
            // The field value won't be set and validated right away, so wrap submitForm in a timeout.
            setTimeout(() => submitForm(), 0);
          }}
        />
      </InputContainer>
    );
  }
);

export default FormikRecaptcha;

